import React from 'react';

import { messageUtility } from '../../utilities/messageUtility';
import { useFieldBulletinBoardDetail } from '../../services/fieldBulletinBoard/FieldBulletinBoardDetailContext';

import { FieldBulletinBoardHeader } from './FieldBulletinBoardHeader';
import { FieldBulletinBoardPublicationStatusChip } from './FieldBulletinBoardPublicationStatusChip';

import { Button } from '@bld/bld-libs/components';
import { BACK_EVENT_SOURCE } from '../../utilities/constants';

export function FieldBulletinBoardsHeaderDetailForPrime() {
  const {
    getDetailInfo,
    getModalDisplayInfo,
    getButtonDisplayInfo,
    handleEdit,
    handleBack,
    handleStop,
    executeStop,
    closeConfirmDialog,
  } = useFieldBulletinBoardDetail();

  const buttonDisplayInfo = getButtonDisplayInfo();

  /**
   * 編集ボタン
   */
  const EditButton = () => {
    return (
      <React.Fragment>
        <Button
          color='primary'
          className='edit-btn'
          variant='contained'
          sx={{ minWidth: '100px', width: '100%' }}
          onClick={() => handleEdit()}
        >
          {messageUtility.getMessage('I-000-166-12')}
        </Button>
      </React.Fragment>
    );
  };

  /**
   * 停止ボタン
   */
  const StopButton = () => {
    return (
      <React.Fragment>
        <Button
          color='error'
          className='stop-btn'
          variant='outlined'
          onClick={() => handleStop()}
          sx={{
            backgroundColor: '#FFFFFF',
            minWidth: '100px',
            width: '100%',
          }}
        >
          {messageUtility.getMessage('I-000-166-13')}
        </Button>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {buttonDisplayInfo.stop ? (
        <FieldBulletinBoardHeader
          masterHeadertitle={messageUtility.getMessage('I-000-166-01')}
          breadcrumbsName={messageUtility.getMessage('I-000-164-01')}
          getModalDisplayInfo={getModalDisplayInfo}
          closeConfirmDialog={closeConfirmDialog}
          handleBack={() => handleBack(BACK_EVENT_SOURCE.BREADCRUMBS)}
          button={<StopButton />}
          executeStop={executeStop}
          description={messageUtility.getMessage('I-000-166-20')}
          status={
            <FieldBulletinBoardPublicationStatusChip
              bulletinBoardPublicationStatusId={
                getDetailInfo().bulletin_board_publication_status
              }
            />
          }
        />
      ) : buttonDisplayInfo.edit ? (
        <FieldBulletinBoardHeader
          masterHeadertitle={messageUtility.getMessage('I-000-166-01')}
          breadcrumbsName={messageUtility.getMessage('I-000-164-01')}
          getModalDisplayInfo={getModalDisplayInfo}
          closeConfirmDialog={closeConfirmDialog}
          handleBack={handleBack}
          button={<EditButton />}
          executeStop={executeStop}
          status={
            <FieldBulletinBoardPublicationStatusChip
              bulletinBoardPublicationStatusId={
                getDetailInfo().bulletin_board_publication_status
              }
            />
          }
        />
      ) : (
        <FieldBulletinBoardHeader
          masterHeadertitle={messageUtility.getMessage('I-000-166-01')}
          breadcrumbsName={messageUtility.getMessage('I-000-164-01')}
          getModalDisplayInfo={getModalDisplayInfo}
          handleBack={handleBack}
          status={
            <FieldBulletinBoardPublicationStatusChip
              bulletinBoardPublicationStatusId={
                getDetailInfo().bulletin_board_publication_status
              }
            />
          }
        />
      )}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardsHeaderDetailForPrime.jsx